import React from 'react';

var _path;

var SvgRedoMajor = function SvgRedoMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.512 5C14.363 3.066 12.522 2 10 2a8 8 0 0 0-8 8 8 8 0 0 0 8 8 1 1 0 1 1 0 2C4.477 20 0 15.523 0 10S4.477 0 10 0c3.297 0 5.644 1.496 8 3.647V1a1 1 0 1 1 2 0v5a.998.998 0 0 1-.29.705l-.005.004A.997.997 0 0 1 19 7h-5a1 1 0 1 1 0-2h2.512z"
  })));
};

export { SvgRedoMajor as S };
